export default __webpack_public_path__ + "static/media/close_blue.49181fa7.svg";